<template>
	<div id="about-app">
		<h2>About This Website</h2>
		<div>
			Just a playground for
			<a href="https://vuejs.org/" target="_blank">Vue.js</a> development.
		</div>

		<br />

		<img
			style="margin: 50px 0;"
			width="250"
			alt="plz help"
			src="@/assets/autism.jpg"
		/>

		<br />

		<h2>Contact</h2>
		<div>
			<a href="mailto:mail@zipixx.com" target="_top">mail@zipixx.com</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'About.vue'
};
</script>

<style scoped>
#about-app {
	margin-top: 25px;
}
a {
	color: #aaf;
}
</style>
